import { Component } from '@angular/core';
import { CatalogoPage } from 'src/app/models/entidad-page.interface';
import { HttpPaginacion, Paginar } from 'src/app/models/http-paginacion.interface';
import { AdministradorService } from 'src/app/services/administrador.service';
@Component({
  selector: 'app-diagnosticos',
  templateUrl: './diagnosticos.component.html',
  styleUrls: ['./diagnosticos.component.scss']
})
export class DiagnosticosComponent {
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 120;
  diagnosticosPageInformacion: HttpPaginacion<CatalogoPage> | undefined;
  diagnosticoPage: CatalogoPage[] = [];
  constructor(private adiministradorService: AdministradorService){
    this.obtenerInformacion(1);
  }

  obtenerInformacion(page: number): void{
    this.adiministradorService.diagnosticos(page)
    .subscribe({
      next: (resp) => { 
        this.diagnosticosPageInformacion = resp;
        this.diagnosticoPage = resp.data;
        
        this.first = (resp.current_page - 1) * resp.per_page;
        this.rows = resp.per_page;
        this.totalRecords = resp.total;
      },
      error: (err) => console.log(err) 
    })
  }

  onPageChange(event: any) {
    const paginar: Paginar = <Paginar>event;
    const paginaActual = paginar.page + 1;
    this.obtenerInformacion(paginaActual);
     
  }
  exportExcel(): void{}
}
